import { render } from "./order.vue?vue&type=template&id=e0f1c6fa&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=e0f1c6fa&scoped=true&lang=less"

import exportComponent from "D:\\perject\\suyuan\\.codex-tmp\\20260929-frontend-prod\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0f1c6fa"]])

export default __exports__